export default __webpack_public_path__ + "static/media/scar.a3c79313.svg";